module.exports = __webpack_public_path__ + "static/media/GAMEZONES.76a07890.png";